export const rpcUrls = {
    fantom: process.env.REACT_APP_FANTOM_RPC_URL,
    mainnet: process.env.REACT_APP_MAINNET_RPC_URL,
    sol: 'https://ofelia-3bh1h8-fast-mainnet.helius-rpc.com',
} as const;

export const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i;
